"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CMultiToggle = _interopRequireDefault(require("01_core/components/materials/CMultiToggle"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 業務内容マルチトグル選択部品
 * @prop {string} labelText - 項目名（変更したい場合のみ）
 * @prop {string} gyomuCdAvail - 権限制御業務内容コード
 * @prop {string} value - 選択値
 * @prop {string} hint - 項目名ヒント（表示する場合のみ）
 * @prop {boolean} required - 必須項目とする場合True
 * @prop {func} onChange - 変更された業務内容「監査部門／被監査部門」を受け取る関数
 */
class SelectGyomuContent extends _react.default.Component {
  render() {
    const {
      intl,
      labelText,
      gyomuCdAvail,
      value,
      hint,
      onChange,
      required,
      getCodeItems
    } = this.props;
    if (gyomuCdAvail === _CodeConsts.CODE.AUTH_GYOMU_CD.CODE_3) {
      // 選択可能な場合のみ表示する
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
        label: labelText ? labelText : intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_GYOMU_CONTENT
        }),
        hint: hint,
        required: required ? required : false
      }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
        options: [...getCodeItems(_CodeConsts.CODE.KANSA_GYOMU_CD.KBN)],
        selectedOption: value,
        onSelectOption: onChange
      })));
    } else {
      return null;
    }
  }
}
SelectGyomuContent.propTypes = {
  labelText: _propTypes.default.node,
  value: _propTypes.default.string.isRequired,
  hint: _propTypes.default.node,
  onChange: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)(SelectGyomuContent));